var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgToggle = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 3.3335C13.2443 3.3335 15.3337 5.42283 15.3337 8.00016C15.3337 10.5775 13.2443 12.6668 10.667 12.6668H5.33366C2.75633 12.6668 0.666992 10.5775 0.666992 8.00016C0.666992 5.42283 2.75633 3.3335 5.33366 3.3335H10.667ZM8.00033 8.00016C8.00033 9.47292 9.19423 10.6668 10.667 10.6668C12.1398 10.6668 13.3337 9.47292 13.3337 8.00016C13.3337 6.5274 12.1398 5.3335 10.667 5.3335C9.19423 5.3335 8.00033 6.5274 8.00033 8.00016Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToggle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Toggle.a3837eb89c788f2d58f78d744e83e106.svg";